import Skeleton from '@cobliteam/ui/components/Skeleton';

const DrawerLoadingSkeleton = () => (
  <div className='flex flex-col gap-4'>
    <div className='flex flex-col gap-2'>
      <div className='flex justify-between gap-4'>
        <div className='flex items-center gap-2'>
          <Skeleton className='size-10 shrink-0 rounded-full' />
          <div className='flex flex-col gap-1'>
            <Skeleton className='h-4 w-24' />
            <Skeleton className='h-5 w-32' />
          </div>
        </div>
        <Skeleton className='h-4 w-20 shrink-0' />
      </div>
      <Skeleton className='h-8 w-full rounded-lg' />
    </div>
  </div>
);

export default DrawerLoadingSkeleton;
